import { render, staticRenderFns } from "./SaleLeadFilter.vue?vue&type=template&id=4b6389a2"
import script from "./SaleLeadFilter.vue?vue&type=script&lang=js"
export * from "./SaleLeadFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports